module.exports = __webpack_public_path__ + "media/Whileyoulisten.339a19fd.mp3";